var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"dots",on:{"click":_vm.handleShowPopup}},[_vm._v(" ... "),(_vm.show)?_c('div',{staticClass:"popup"},[_c('ul',[_c('li',{on:{"click":_vm.viewNFT}},[_vm._v("Ver")]),_c('li',{on:{"click":_vm.putOnSale}},[_vm._v("Poner en venta")]),_c('li',[_vm._v("Eliminar")])])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }